module.exports = __webpack_public_path__ + "static/img/001.588c9002.png";